module.exports = __webpack_public_path__ + "img/16.a2c5720c.webp";